import React from 'react'
import { Badge, Col, Container, Row } from 'reactstrap'

const Testi = () => {
  return (
    <section className="section pt-0">
      <Container>
        <div className="extension-final-cta">
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <Badge pill className="extension-badge extension-badge-light mb-3">
                Start for free
              </Badge>
              <h3>Install it once. Keep learning every time you browse.</h3>
              <p>
                HighVocab helps you capture useful words, understand them
                instantly, and remember them with less effort over time.
              </p>
              <div className="mt-4 pt-2">
                <a
                  href="https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-light"
                >
                  Install the extension
                  <i className="mdi mdi-arrow-right ms-2"></i>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default Testi
